// extracted by mini-css-extract-plugin
export default {"policiesContainer":"bOv8YG","minimalContainer":"WjNCH_","mobilePoliciesContainer":"xAI_Tn","desktopPoliciesContainer":"FdNhcR","policiesLink":"YlAxcQ"};